// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__XF8v1","topBottomGutter":"Layout_topBottomGutter__rm-cs"};